<script>
    import { DetailOnCapture } from '../../script/handle/detail'

    export let ShowLoadingModal, OnCapture, CountTimer

	let dialog;

    $: if (dialog && ShowLoadingModal) {
        dialog.showModal()
        timerCheck()
        DetailOnCapture()
    }
    
    // 타이머 진행
    function timerCheck() {
        let intervalId = setInterval(() => {
            CountTimer--
            
            if(CountTimer <= 0) {
                clearInterval(intervalId)
                closeModal()
            }
        }, 1000);
    }

    // Modal 종료
	function closeModal() {
		ShowLoadingModal = false
        OnCapture = false
		dialog.close()
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog
	bind:this={dialog}
	on:close={() => closeModal()}
    class='loadingModal'
>
	<!--<div class='monsterModal' on:click|stopPropagation>-->
    <div class="title">작업 진행중</div>

    <div class="issue">
        잠시만 기다려 주세요.<br>
        Waiting for second {CountTimer}...

        {#if OnCapture}
            <br><br>외부 공유시 출처 표시 부탁드립니다!
        {/if}
    </div>
</dialog>

<style lang='scss'>
    dialog {
        border-radius: 4px;
        border: 1px solid #ffffff;
        padding: 0;
        background-color: $cl1;
        color: #ffffff;

        & > div {
            padding: 10px;
        }

        &::backdrop {
            background: rgba(0, 0, 0, 1.0);
        }

        &[open] {
            animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes zoom {
            from {
                transform: scale(0.95);
            }
            to {
                transform: scale(1);
            }
        }
        &[open]::backdrop {
            animation: fade 0.2s ease-out;
        }
        @keyframes fade {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
    }

    .loadingModal {
        padding: 10px;
        text-align: center;

        .title {
            color: $cl4;
            font-size: 24px;
            font-family: aggro;
        }
        .issue {
            color: $cl2;
            font-size: 18px;
        }
    }
</style>
